import { Box, Grid, Stack } from "@mui/system";

import VerticalLinearStepper from "../VerticalLinearStepper";

import { RecapCard } from "../../RecapCard";
import { Alert, List, ListItem, Typography } from "@mui/material";
import { LiveCodeBlock } from "../../LiveCodeBlock";

export const KdappontLesson6 = () => {
  const subjectBlocks = [
    {
      label: "Forms",
      main: (
        <>
          <LiveCodeBlock
            code={`<form>
    <fieldset>
        <legend>Personal</legend>
        <label for="firstname">First name:</label><br/>
        <input type="text" id="firstname" name="firstname"><br/>
        <label for="lastname">Last name:</label><br/>
        <input type="text" id="lastname" name="lastname"><br/>
    </fieldset>

    <fieldset>
        <legend>Address</legend>
        <label for="street">Street</label><br/>
        <input type="text" id="street" name="street"><br/>

        <label for="country">Country</label><br/>

        <select>
            <option>Make a choice</option>
            <optgroup label="EU">
                <option>NL</option>
                <option>BE</option>
            </optgroup label="EU">
        </select>
            
        <br/><br/>

        <input type="submit" value="Send">
    </fieldset>
</form>`}
          />
          <br />
          Het HTML &lt;form&gt;-element wordt gebruikt om een HTML-formulier
          voor gebruikersinvoer te maken
        </>
      ),
    },
    {
      label: "Form attributen",
      main: (
        <>
          <LiveCodeBlock
            code={`
<form action="/action_page.php" target="_blank" method="get">
  ...
</form>`}
          />

          <br />

          <Stack direction="row" spacing={7}>
            <Box>
              <strong>action</strong>
              <List>
                <ListItem>
                  De URL waar je de formulier <br />
                  data heenstuurt
                </ListItem>
              </List>
            </Box>

            <Box>
              <strong>target</strong>
              <List>
                <ListItem>Huidige venster overschrijven</ListItem>
                <ListItem>of nieuwe tabblad openen</ListItem>
              </List>
            </Box>

            <Box>
              <strong>method</strong>
              <List>
                <ListItem>Waar wil je naartoe?</ListItem>
                <ListItem>Intern, Extern, #</ListItem>
              </List>
            </Box>
          </Stack>

          <hr />

          <br />

          <Typography variant="h5">Form elements</Typography>

          <br />

          <LiveCodeBlock
            code={`<input>
<label>
<select>
<textarea>
<button>
<fieldset>
<legend>
<option>
<optgroup>
              `}
          />
        </>
      ),
    },
    {
      label: "Input element",
      main: (
        <>
          <LiveCodeBlock
            code={`<form>
  <input type="button" />
  <input type="checkbox" />
  <input type="color" />
  <input type="date" />
  <input type="datetime-local" />
  <input type="email" placeholder="e-mail" required />
  <input type="file" />
  <input type="hidden" />
  <input type="month" />
  <input type="number" placeholder="number" required />
  <input type="password" placeholder="password" required />
  <input type="radio" />
  <input type="range" required />
  <input type="reset" />
  <input type="submit" />
  <input type="tel" placeholder="tel" required />
  <input type="text" placeholder="text" required />
  <input type="time" />
  <input type="week" />
</form>
              `}
          />
        </>
      ),
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: " 🗓️ Planning",
          description: "",
          content: (
            <>
              <img
                src="/presentation-data/KDAPPONT2/lesson6/planning-l6.png"
                width="100%"
                alt=""
              />
            </>
          ),
        },
        {
          label: "👨🏼‍🏫 Voor vandaag | Les #6 | HTML Forms",
          description: ``,
          content: (
            <Grid container columns={4} spacing={2}>
              {subjectBlocks.map((subject) => (
                <Grid size={2} sx={{ "& > *": { height: "100%" } }}>
                  <RecapCard subject={subject} />
                </Grid>
              ))}
            </Grid>
          ),
        },
        {
          label: "🚀 Digitaal Lesmateriaal - W3Schools - Aan de slag!",
          description: `Digitaal lesmateriaal ➡️ KD Appont ➡️ Module 1 :: HTML ➡️ LES 6`,
          content: (
            <Alert severity="error" sx={{ alignItems: "center" }}>
              <Typography variant="h5">
                Maak uiteraard eerst je oefeningen en opdrachten van Les 5 af
              </Typography>
            </Alert>
          ),
        },
      ]}
    />
  );
};
